import { Tenant } from "../models/Tenant";

const assets = {
  logo: require("../assets/logo_horizontal.svg").default,
  logoDark: require("../assets/logo_horizontal_dark.svg").default,
};

interface Props {
  href?: string;
  tenant?: Tenant;
  className?: string;
}

const LogoHorizontal: React.FC<Props> = ({ tenant, className, href }) => {
  const isDarkMode = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  if (tenant?.logoUrl) {
    return (
      <img
        src={
          isDarkMode() && tenant.logoUrlDark
            ? tenant.logoUrlDark
            : tenant.logoUrl
        }
        alt="Logo"
        className={className}
      />
    );
  }
  return (
    <img
      src={isDarkMode() ? assets.logoDark : assets.logo}
      alt="Logo"
      className={className}
      style={{ cursor: href ? "pointer" : "default" }}
      onClick={() => href && window.open(href, "_blank")} // Open in new tab
    />
  );
};

export default LogoHorizontal;
